import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { SITE_NAME } from "../../config/site";

const KEY = "age_gate_ok";

export default function AgeGate() {
  const [visible, setVisible] = useState(() => sessionStorage.getItem(KEY) !== "1");
  const navigate = useNavigate();

  if (!visible) return null;

  const confirm = () => {
    sessionStorage.setItem(KEY, "1");
    setVisible(false);
  };

  const minor = () => {
    sessionStorage.setItem(KEY, "1");
    setVisible(false);
    navigate("/jeu-responsable");
  };

  return (
    <div
      data-testid="age-gate"
      role="dialog"
      aria-modal="true"
      aria-labelledby="age-gate-title"
      className="fixed inset-0 z-[100] flex items-center justify-center bg-[#0B1F3A]/90 p-4 backdrop-blur-md"
    >
      <div className="w-full max-w-md rounded-2xl bg-white p-8 text-center shadow-2xl">
        <span className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-[#E8F8F3]">
          <ShieldCheck className="h-7 w-7 text-[#2BB08A]" aria-hidden="true" />
        </span>
        <h2 id="age-gate-title" className="font-display text-xl font-semibold text-[#0B1F3A]">
          Vérification de l'âge
        </h2>
        <p className="mt-3 text-[15px] leading-relaxed text-slate-600">
          Ce site s'adresse exclusivement aux personnes majeures (18 ans et plus).{" "}
          {SITE_NAME} est un guide pédagogique : il ne propose aucun pari et aucune
          inscription à un opérateur.
        </p>
        <div className="mt-6 flex flex-col gap-3">
          <button
            type="button"
            data-testid="age-gate-confirm"
            onClick={confirm}
            className="rounded-full bg-[#0B1F3A] px-6 py-3 font-display text-sm font-semibold text-white transition-colors hover:bg-[#16305a]"
          >
            J'ai 18 ans ou plus
          </button>
          <button
            type="button"
            data-testid="age-gate-minor"
            onClick={minor}
            className="rounded-full border border-slate-300 px-6 py-3 font-display text-sm font-semibold text-slate-600 transition-colors hover:border-slate-400 hover:text-[#0B1F3A]"
          >
            Je suis mineur
          </button>
        </div>
      </div>
    </div>
  );
}
